import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { useTranslation } from 'react-i18next';

type Props = {
  label?: string;
  disabled?: boolean;
  onDownload: () => Promise<void>;
};

export function ReportDownloadPdfButton({
  label,
  disabled = false,
  onDownload,
}: Props) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      await onDownload();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled || busy}
      startIcon={busy ? <CircularProgress size={18} color="inherit" /> : <PictureAsPdfOutlinedIcon />}
      onClick={handleClick}
      fullWidth
      sx={{ px: 2.5 }}
    >
      {label ?? t('esgReports.downloadPdf')}
    </Button>
  );
}
